import { useCallback, useState } from 'react';

export function useDialog(defaultOpen: boolean = false): [boolean, () => void, () => void] {
  const [open, setOpen] = useState(defaultOpen);
  const onClose = useCallback(() => setOpen(false), []);
  const onOpen = useCallback(() => setOpen(true), []);
  return [open, onOpen, onClose];
}
